export const defaultLocale = 'en';

export const locales = [{
  code: 'en',
  name: 'English'
},{
  code: 'es',
  name: 'Español'
}];



// WEBPACK FOOTER //
// ./src/i18n/config.js